import React, { useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { themeContext } from "../../../Context";
import { CLOUD_URL } from "../../../seo/seoConfig";
import "./ErpHero.css";

const ErpHero = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="erp-hero" id="erp-hero">
      <div className="erp-hero-inner">
        <p className="erp-hero-brand">Litesoft</p>
        <p className="erp-hero-eyebrow">
          انطلاقاً من رؤية المملكة 2030 — جاهزون للفوترة الإلكترونية وZATCA
        </p>
        <h1 className="erp-hero-title" style={{ color: darkMode ? "white" : undefined }}>
          برنامج محاسبة ونظام ERP متكامل لإدارة أعمالك
        </h1>
        <p className="erp-hero-sub">
          المبيعات والمشتريات والمخزون والحسابات والتقارير في منصة واحدة، مع أنظمة
          قطاعية متخصصة ودعم يساعدك على التشغيل اليومي بثقة.
        </p>
        <div className="erp-hero-actions">
          <a
            className="button erp-hero-btn"
            href={CLOUD_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            ابدأ الاستخدام مجاناً
          </a>
          <ScrollLink to="contact" spy={true} smooth={true} offset={-40}>
            <button type="button" className="button erp-hero-btn erp-hero-btn-secondary">
              اطلب عرض سعر
            </button>
          </ScrollLink>
        </div>
      </div>
      <div className="erp-hero-glow" aria-hidden="true" />
    </section>
  );
};

export default ErpHero;
